<template lang="pug">
  .component-translation-action-buttons
    button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"

  export default {
    name: "TranslationButtons",
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>T${this.item.id} translation?</strong>`, () => {
          KeplerBackofficeSdk.translations.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', "Translation removed")
            this.$nextTick(() => {
              window.location.reload()
            })
          })
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TranslationButtons.vue?dfc62aa0